module.exports = __webpack_public_path__ + "img/cloud-sync.eaec4aa4.svg";